import { IPersonListState } from './states.store'
import { MutationTree } from 'vuex';

const mutations: MutationTree<IPersonListState> = <MutationTree<IPersonListState>>{
}

export default mutations;